<div class="popup-header">
  {{ configForm.get('number')?.value }} - {{ configForm.get('name')?.value }}
</div>

<form>
  <div mat-dialog-content>
    <mat-tab-group>
      <!-- CONFIG TAB -->


      <!-- CONTACTS TAB -->
      <mat-tab label="Kunder">
        <div class="container py-3">
      
          <!-- 1. Multi-select dropdown to add kunder -->
          <h5 class="mt-4">Add Kunder</h5>
          <mat-form-field appearance="outline" class="w-100 mb-3">
            <mat-label>Select Kunder</mat-label>
            <mat-select [(value)]="selectedKunder">
              <mat-option *ngFor="let k of allKunder" [value]="k">
                {{ k.name }} ({{ k.email }})  <button mat-flat-button color="primary" (click)="addSelectedKunder(k.kundekortId)">
                  Add Selected
                </button>
              </mat-option>
            </mat-select>
          </mat-form-field>
         
                <ng-container *ngIf="connectedKunder.length; else noConnected">
            <mat-list class="connected-kunder-list">
          
              <ng-container *ngFor="let c of connectedKunder">
                <mat-card class="example-card" appearance="outlined">
                  <mat-card-content>
                    <mat-card-title>{{ c.name }}</mat-card-title>
                    <p> {{ c.email }} &bull; {{ c.phone }}
                   
                    <mat-chip-set aria-label="Chihuahua traits">
                      <mat-chip (click)="showConnectedKunder(c.dbid!)"> Show </mat-chip>
                      <mat-chip (click)="removeConnectedKunde(c.dbid!)">delete</mat-chip>
                    </mat-chip-set>
                  </p>
                  </mat-card-content>
                
                </mat-card>
              
              </ng-container>
          
            </mat-list>
          </ng-container>
          
          <ng-template #noConnected>
            <p class="empty-list text-center">No connected kunder.</p>
          </ng-template>
      
          <div align="end" class="p-3 border-top">
            <button mat-raised-button color="warn" (click)="onNoClick()">Close</button>
          </div>
        </div>
      </mat-tab>
      

      <!-- NOTATER TAB -->
      <mat-tab label="Notater">
        <div class="container py-3" [formGroup]="notaterForm">
          <h5>Add Note</h5>
          <div class="mb-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Note Text <span class="text-danger">*</span></mat-label>
              <textarea matInput rows="3" formControlName="text" 
                        [ngClass]="{'is-invalid': notaterForm.get('text')?.invalid && notaterForm.get('text')?.touched}"></textarea>
              <mat-error *ngIf="notaterForm.get('text')?.invalid && notaterForm.get('text')?.touched">
                Note text is required.
              </mat-error>
            </mat-form-field>
          </div>
          <div class="row mb-3">
            <div class="col-md-6">
              <mat-form-field appearance="fill" class="w-100">
                <mat-label>Note Date <span class="text-danger">*</span></mat-label>
                <input matInput [matDatepicker]="noteDatePicker" formControlName="noteDate"
                       [ngClass]="{'is-invalid': notaterForm.get('noteDate')?.invalid && notaterForm.get('noteDate')?.touched}">
                <mat-datepicker-toggle matSuffix [for]="noteDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #noteDatePicker></mat-datepicker>
                <mat-error *ngIf="notaterForm.get('noteDate')?.invalid && notaterForm.get('noteDate')?.touched">
                  Note date is required.
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-md-4">
              <mat-form-field appearance="fill" class="w-100">
                <mat-label>Reminder Date (optional)</mat-label>
                <input matInput [matDatepicker]="reminderPicker" formControlName="reminderDate">
                <mat-datepicker-toggle matSuffix [for]="reminderPicker"></mat-datepicker-toggle>
                <mat-datepicker #reminderPicker></mat-datepicker>
              </mat-form-field>
            </div>
            <div class="col-md-2">
              <mat-form-field appearance="fill" class="w-100">
                <mat-label>Time</mat-label>
                <input matInput type="time" formControlName="reminderTime">
              </mat-form-field>
            </div>
          </div>
          <div align="end" class="p-3 border-top">
            <button mat-raised-button color="primary" (click)="saveNote()">Save Note</button>
            <button mat-raised-button color="warn" (click)="onNoClick()">Close</button>

          </div>
          <h5 class="mt-5">Previous Notes</h5>
          <mat-list *ngIf="savedNotater.length > 0">
            <mat-list-item *ngFor="let note of savedNotater">
              <div class="w-100">
                <p class="mb-1"><strong>{{ note.noteDate.toDate() | date }}</strong>: {{ note.text }}</p>
                <small *ngIf="note.reminderDate">Reminder: {{ note.reminderDate.toDate() | date:'medium' }}</small>
              </div>
            </mat-list-item>
          </mat-list>
        </div>
      </mat-tab>

      <!-- ATTACHMENTS TAB -->
      <!-- <mat-tab label="Attachments">
        <div class="container py-3">
          <div class="mb-4">
            <label for="fileUpload" class="form-label">Upload Attachment</label><br>
            <input type="file" id="fileUpload" (change)="onFileSelected($event)" multiple>
          </div>
          <div *ngIf="attachments.length > 0">
            <h5>Uploaded Attachments</h5>
            <ul class="list-group">
              <li *ngFor="let att of attachments; let i = index" class="list-group-item d-flex justify-content-between align-items-center">
                <a [href]="att.url" target="_blank">{{ att.name }}</a>
                <button type="button" mat-icon-button color="warn" (click)="removeAttachment(i)">
                  <mat-icon>delete</mat-icon>
                </button>
              </li>
            </ul>
          </div>
          <mat-progress-bar *ngIf="uploadProgress > 0 && uploadProgress < 100" mode="determinate" [value]="uploadProgress"></mat-progress-bar>
        </div>
        <div align="end" class="p-3 border-top">
          <button mat-raised-button color="primary" (click)="saveAttachments()">Save Attachments</button>
          <button mat-raised-button color="warn" (click)="onNoClick()">Close</button>

        </div>
      </mat-tab> -->
    </mat-tab-group>
  </div>

</form>